import easyAutocomplete from './vendors/jquery.easy-autocomplete.min.js';
import intlTelInput from 'intl-tel-input';
import { triggerChange } from './commons/eventTarget';
import { setUserCurrencyByIp } from './commons/commonPricing.js';
import { initQuotes } from './quotes-component/initQuotes.js';

$(document).ready(function () {
  var $window = $(window),
    $body = $('body'),
    $captador = $('#captador'),
    $captadorClose = $('#captador .close'),
    $header = $('header'),
    $languageSelector = $('.language-selector'),
    $languageOption = $('.language-selector:not(.disabled) .option.selected'),
    $menuOpen = $('#open-menu'),
    $menuClose = $('#close-menu'),
    $modal = $('#modal-video .c-modal__content'),
    $modalVideoClose = $('.c-modal__close'),
    $hideDownloadButton = $('figure form .icon-close'),
    $showIntegrationsButton = $('figure .show-integrations'),
    $showLessButton = $('#show-less'),
    $showMoreButton = $('#show-more'),
    $showMoreContent = $('#more'),
    // typewriter = $('.typewriter')[0],
    $accordionSeeMore = $('#see-more'),
    $accordionItem = $('ul.accordion li'),
    $accordionCrossMore = $('.cross-more'),
    $accordionComplete = $('.description-complete'),
    $vLang = $('html').attr('lang'),
    $navSubnavigation = $('.sub-navigation li'),
    $navSubnavigationOpen = $('.sub-navigation .header a'),
    $navSubnavigationClose = $('.sub-navigation__close'),
    $buttonChatBot = $('.chatbot__link'),
    $phoneInput = $('#phone-input'),
    $buttonAncore = $('.button'),
    $singleAccordionItem = $('.accordion-single li'),
    $tabsAutomation = $('.c-tabs'),
    $tabsResource = $('.nav-resources-tabs'),
    $contentResources = $('.resource-content'),
    $navResourcesOpen = $('.resources-tabs .header a'),
    $navResourcesClose = $('.resources-tabs__close'),
    $copyResource = $('.tab-copy');



  const sliderContainer = document.getElementById('quotesContainer');
  if (sliderContainer) {
    initQuotes($, sliderContainer);
  }

  const retinaImages = document.querySelectorAll('.retina-img');



  if (navigator.userAgent.indexOf('Edge') >= 0) {
    $('.progress-bar').addClass('ie-css');
  } else {
    $('.progress-bar').removeClass('ie-css');
  }

  // if (!!typewriter) {
  //   setTimeout(function () {
  //     new TxtRotate(typewriter);
  //   }, 5000);
  // }

  if ($navSubnavigation) {
    load_SubmenuNavigation($navSubnavigation);
  }

  if ($window.scrollTop() === 0) {
    $header.addClass('top');
  }



  /*Function to resize Retina Imgs*/


  retinaImages.forEach(function (img) {
    img.addEventListener('load', function () {
      let currWidth = this.naturalWidth;
      if (currWidth > 0 && window.innerWidth > 480) {
        currWidth = currWidth / 2;
        this.style.maxWidth = currWidth + 'px';
      }
    }, { once: true });

    if (img.complete) {
      const event = new Event('load');
      img.dispatchEvent(event);
    }
  });


  if (!!document.location.hash) {
    var hash = document.location.hash;
    if ($(hash).length > 0) {
      var height = $(hash).offset().top - 74;
      $window.scrollTop(height);
    }
  }

  /* Pages Resources/Integrations - Add same value to attr ID of checkbox and attr FOR of label ( add it dinamically)*/
  $('.section--destacado .checkbox, .integrations .checkbox').each(function (
    val,
    key,
  ) {
    $(this)
      .find('input[type=checkbox]')
      .attr('id', 'checkbox-form-' + val);
    $(this)
      .find('label')
      .attr('for', 'checkbox-form-' + val);
  });


  // Save position the data-active-tab when you click
  $('.nav-resources-tabs li a.tab-indicator').click(function () {
    if (history.pushState) {
      history.pushState(null, null, '#' + $(this).attr('data-href'));
    } else {
      location.hash = '#' + $(this).attr('data-href');
    }
  });

  if ($buttonChatBot.length > 0) {
    $buttonChatBot.on('click', function (event) {
      event.preventDefault();
      openChatBot();
    });
    setTimeout(function () {
      document.getElementById('chatbot__welcome').style.visibility = 'visible';
    }, 4000);
  } else {
    setTimeout(function () {
      $('#titlediv').addClass('hide');
    }, 6000);
  }

  $buttonAncore.click(function () {
    var attr = $(this).attr('data-href');
    /* In some browsers, 'attr' is undefined, for others, 'attr' is false*/
    if (typeof attr !== typeof undefined && attr !== false) {
      window.location.href = attr;
    }
  });

  $window.on('hashchange', function () {
    var height = $window.scrollTop();

    $window.scrollTop(height - 74);
  });

  $window.on('click', function (event) {
    if (
      $languageSelector.has(event.target).length == 0 &&
      !$languageSelector.is(event.target)
    ) {
      $languageOption.removeClass('open');
    }
  });

  $window.on('scroll', function () {
    var position = $window.scrollTop();

    if (position === 0) {
      $header.addClass('top');
      $('#register, #register_mobile').addClass('hide');
      $('#register_top, #register_top_mobile').removeClass('hide');
    } else {
      $header.removeClass('top');
      $('#register_top, #register_top_mobile').addClass('hide');
      $('#register, #register_mobile ').removeClass('hide');
    }

    autoplayVideos();
  });

  $window.on('resize', function () {
    autoplayVideos();
  });

  $languageOption.on('click', function () {
    $languageOption.toggleClass('open');
  });

  $showMoreButton.on('click', function () {
    $showMoreButton.hide();
    $showMoreContent.show();
    $showLessButton.show();
    return false;
  });

  $showLessButton.on('click', function () {
    $showMoreButton.show();
    $showMoreContent.hide();
    $showLessButton.hide();
    return false;
  });

  $menuOpen.on('click', function () {
    $header.addClass('open');
    return false;
  });

  $menuClose.on('click', function () {
    $header.removeClass('open');
    return false;
  });

  /*To allow only numbers, dash, parenthesis in library*/
  $phoneInput.keypress(function (e) {
    if (
      e.which != 8 &&
      e.which != 0 &&
      (e.which < 48 || e.which > 57) && // only numbers
      e.which != 32 && // space
      e.which != 40 && // right parenthesis
      e.which != 41 && // left parenthesis
      e.which != 45 // dash
    ) {
      return false;
    }
  });

  $navSubnavigationOpen.on('click', function (e) {
    e.preventDefault();
    var $submenuOptions = $(this).closest('nav').find('ul');

    if ($submenuOptions.hasClass('open')) {
      $submenuOptions.removeClass('open').addClass('hide');
    } else {
      $submenuOptions.removeClass('hide').addClass('open');
    }
  });

  $navSubnavigationClose.on('click', function (e) {
    e.preventDefault();
    $(this).parent().removeClass('open').addClass('hide');
  });

  $('form .holder .required').blur(function () {
    if (!$(this).hasClass('phone-number')) {
      if ($(this).closest('.holder').hasClass('error') && $(this).val()) {
        $(this).closest('.holder').removeClass('error');
      }
    }
  });

  $('form .holder .check.required').click(function () {
    if (
      $(this).closest('.holder').hasClass('error') &&
      $(this).is(':checked')
    ) {
      $(this).closest('.holder').removeClass('error');
    }
  });

  $showIntegrationsButton.on('click', function (e) {
    var hash = this.hash,
      height = $(hash).offset().top - 74,
      email = '',
      $figure = $(this.hash),
      $emailInput = $figure.find('input[type=email]');

    if (document.location.hash === hash) {
      e.preventDefault();
      $(window).scrollTop(height);
    }

    $('figure.open').removeClass('open');
    $emailInput.val(email);
    $figure.addClass('open');
    $figure.addClass('active');
  });

  $hideDownloadButton.on('click', function (e) {
    e.preventDefault();
    $('figure.open').removeClass('open');
  });

  $showIntegrationsButton.on('click', function (e) {
    var hash = this.hash,
      height = $(hash).offset().top - 74,
      email = '',
      $figure = $(this.hash),
      $emailInput = $figure.find('input[type=email]');

    if (document.location.hash === hash) {
      e.preventDefault();
      $(window).scrollTop(height);
    }

    $('figure.open').removeClass('open');
    $emailInput.val(email);
    $figure.addClass('open');
    $figure.addClass('active');
  });

  $modalVideoClose.on('click', function (e) {
    $body.removeClass('show-modal');
    $modal.html('');
    return false;
  });

  $captadorClose.on('click', function (e) {
    $captador.hide();
    return false;
  });

  /*Single Accordion Tab for Features Sections*/
  $singleAccordionItem.on('click', function (e) {

    $(this).parent().find('li').removeClass('active');

    $(this).addClass('active');

    if ($('#accordion-img-2').hasClass('show')) {
      $('#accordion-img-2').removeClass('show');
      $('#accordion-img-1').addClass('show');
    } else {
      $('#accordion-img-1').removeClass('show');
      $('#accordion-img-2').addClass('show');
    }
  });
  /*End Single Acc.*/

  $accordionSeeMore.on('click', function (e) {
    var $that = $(this),
      vLang = $vLang;

    $accordionComplete.slideToggle('slow', function () {
      if ($(this).is(':visible')) {
        $that.text(vLang == 'en' ? 'READ LESS' : 'LEER MENOS');
      } else {
        $that.text(vLang == 'en' ? 'READ MORE' : 'LEER MÁS');
      }
    });
  });

  $accordionCrossMore.on('click', function (e) {
    var position = $('#main-description').offset().top - 30;

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('html, body').animate(
        {
          scrollTop: position,
        },
        500,
      );
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(300);
    }
  });

  $accordionItem.on('click', function (e) {
    var position = $(this).offset().top - 80;
    $(this).find('.accordion-content').click(false);

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('html, body').animate(
        {
          scrollTop: position,
        },
        500,
      );
      $(this).find('.accordion-panel').stop().slideUp(500);
    } else {
      $(this).addClass('active');
      $(this).find('.accordion-panel').stop().slideDown(500);
      $('a').click(function (e) {
        e.stopPropagation();
      });
    }
  });

  // Save position the data-active-tab when you click
  $tabsAutomation.click(function () {
    sessionStorage.setItem('automation', $(this).attr('data-active-tab'));
    if (history.pushState) {
      history.pushState(null, null, '#' + $(this).attr('data-href'));
    } else {
      location.hash = '#' + $(this).attr('data-href');
    }
  });

  // Function for tabs in resources the marketing
  if ($vLang == 'es') {
    var anchor = [
      '#comportamiento-sitio',
      '#comportamiento-emails',
      '#email-bienvenida',
      '#campanas-sms',
      '#fechas-programadas',
      '#envio-rss',
      '#carrito-abandonado',
      '#producto-visitado',
    ];
  }

  if ($vLang == 'en') {
    var anchor = [
      '#on-site-traking',
      '#campaign-activity',
      '#welcome-email',
      '#sms-campaigns',
      '#scheduled-date',
      '#rss-to-email',
      '#abandoned-cart',
      '#product-retargeting',
    ];
  }

  // Indicate the position when the data is save in sessionStorage
  if ($('body main').hasClass('automation')) {
    if (
      window.location.hash != '' &&
      $.inArray(window.location.hash, anchor) != -1
    ) {
      var pos = $.inArray(window.location.hash, anchor) + 1;
      $tabsAutomation.attr('data-active-tab', pos);
      $tabsAutomation.attr('data-href', window.location.hash.substring(1));
      setTimeout(function () {
        $('html, body').animate(
          {
            scrollTop: $('.section--tabs').offset().top - 50,
          },
          1000,
        );
      }, 500);
    }
    if (!sessionStorage.getItem('automation')) {
      var $active_tab = $tabsAutomation.attr('data-active-tab');
      $($tabsAutomation).find('.c-tabs__tab-indicator').removeClass('active');
      $($tabsAutomation)
        .find(
          '.c-tabs__tab-indicator[data-indicator-tab="' + $active_tab + '"]',
        )
        .addClass('active');
      sessionStorage.setItem('automation', $active_tab);
    } else {
      var $tabIndicatorSelected = $($tabsAutomation).find(
        '.c-tabs__tab-indicator[data-indicator-tab="' +
        sessionStorage.getItem('automation') +
        '"]',
      );
      $($tabsAutomation).attr(
        'data-active-tab',
        sessionStorage.getItem('automation'),
      );
      $($tabsAutomation).attr(
        'data-href',
        $tabIndicatorSelected.attr('data-href'),
      );
      $($tabsAutomation).find('.c-tabs__tab-indicator').removeClass('active');
      $tabIndicatorSelected.addClass('active');

      if (history.pushState) {
        history.pushState(
          null,
          null,
          '#' + $($tabsAutomation).attr('data-href'),
        );
      } else {
        location.hash = '#' + $($tabsAutomation).attr('data-href');
      }
      setTimeout(function () {
        $('html, body').animate(
          {
            scrollTop: $('.section--tabs').offset().top - 50,
          },
          1000,
        );
      }, 500);
    }
  }

  // Tabs functionality Automation
  $('.automation .c-tabs__tab-indicator').each(function (index) {
    $(this).on('click', function (e) {
      var dataHref = $(this).attr('data-href');
      $(this).parent().attr('data-href', dataHref);
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: $('.section--tabs').offset().top - 50,
        },
        1000,
      );
      $('.c-tabs__tab-indicator').removeClass('active');
      $(this)
        .parent()
        .attr('data-active-tab', index + 1);
      $(this).addClass('active');
    });
  });

  $('#c-tabs__left').click(function (e) {
    e.preventDefault();
    var $active_tab = parseInt($(this).parent().attr('data-active-tab')),
      $tabsNumber = parseInt($(this).parent().attr('data-total-tabs'));

    if ($active_tab > 1) {
      $('.c-tabs__tab-indicator').removeClass('active');
      $(this)
        .parent()
        .attr('data-active-tab', $active_tab - 1);
      $('.c-tabs__tab-indicator')
        .eq($active_tab - 2)
        .addClass('active');
      $('html, body').animate(
        {
          scrollTop: $('.section--tabs').offset().top,
        },
        1000,
      );
      if ($active_tab == 2) {
        $(this).addClass('disabled');
      } else if ($active_tab == $tabsNumber) {
        $(this)
          .closest('.c-tabs')
          .find('#c-tabs__right')
          .removeClass('disabled');
      }

      sessionStorage.setItem('automation', $active_tab);
    }
  });

  $('#c-tabs__right').click(function (e) {
    e.preventDefault();
    var $tabsNumber = parseInt($(this).parent().attr('data-total-tabs')),
      $active_tab = parseInt($(this).parent().attr('data-active-tab'));

    if ($active_tab < $tabsNumber) {
      $('.c-tabs__tab-indicator').removeClass('active');
      $(this)
        .parent()
        .attr('data-active-tab', $active_tab + 1);
      $('.c-tabs__tab-indicator').eq($active_tab).addClass('active');
      $('html, body').animate(
        {
          scrollTop: $('.section--tabs').offset().top,
        },
        1000,
      );

      if ($active_tab == $tabsNumber - 1) {
        $(this).addClass('disabled');
      } else if ($active_tab == 1) {
        $(this)
          .closest('.c-tabs')
          .find('#c-tabs__left')
          .removeClass('disabled');
      }

      sessionStorage.setItem('automation', $active_tab);
    }
  });
  // End Tabs functionality Automation

  //** Functions definitions **//
  function autoplayVideos() {
    $('video.bg-video').each(function () {
      if ($(this).is(':visible')) {
        $(this).attr('playsinline', true);
        $(this)[0].play();
      } else {
        $(this)[0].pause();
      }
    });
  }

  function TxtRotate(el) {
    var toRotate = JSON.parse(el.getAttribute('data-rotate')),
      period = el.getAttribute('data-period'); // Tiempo entre cada frase

    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = '';
    this.tick();
    this.isDeleting = false;
  }

  function load_SubmenuNavigation(submenu) {
    var id_selected = submenu.closest('nav').attr('data-active'),
      item_active = submenu.closest('nav').find('.item-active span');

    submenu.each(function () {
      if ($(this).is('#' + id_selected)) {
        item_active.text($(this).find('a').text());

        $(this).addClass('hide');
      } else {
        $(this).removeClass('hide');
      }
    });
  }

  TxtRotate.prototype.tick = function () {
    var i = this.loopNum % this.toRotate.length,
      fullTxt = this.toRotate[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<div class="wrap">' + this.txt + '</div>';

    var that = this,
      delta = 250 - Math.random() * 100; // Tiempo de escritura entre letras

    if (this.isDeleting) {
      delta /= 2;
    }

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(function () {
      that.tick();
    }, delta);
  };


  function getRowVisible(p_gridName) {
    var v_len = $(p_gridName + ' .row').length - 1,
      v_maxShow = $(p_gridName).attr('data-rows'),
      v_max;

    $(p_gridName + ' .row').removeClass('visible');
    var v_begin = $(p_gridName + ' .row.selected').index();

    if (v_maxShow == 4) {
      if (v_begin >= v_len - 1) {
        v_begin = v_begin - 1;
      } else if (v_begin == 0) {
        v_begin = 1;
      }
    } else if (v_maxShow == 5) {
      if (v_begin >= v_len - 1) {
        v_begin = v_begin - 2;
      } else if (v_begin > 2) {
        v_begin = v_begin - 1;
      } else {
        v_begin = 1;
      }
    }
    v_max = parseInt(v_begin) + parseInt(v_maxShow);
    for (var i = v_begin; i < v_max; i++) {
      $(p_gridName + ' .row:nth-child(' + i + ')').addClass('visible');
    }
  }


  var options = {
    //url: "https://restcountries.eu/rest/v2/all",
    url:
      $('#url_home').val() +
      '/wp-content/themes/doppler_site/js/json/json_' +
      $vLang +
      '.json',

    getValue: 'name',

    template: {
      type: 'custom',
      method: function (value, item) {
        return "<img  src='" + item.flag + "' />" + value;
      },
    },

    list: {
      match: {
        enabled: true,
      },
      onChooseEvent: function () {
        var selectedItemValue = $('#country-input').getSelectedItemData().name,
          selectedCode = $('#country-input').getSelectedItemData().code;

        if (selectedItemValue != undefined) {
          $('#country-input').attr('data-name', selectedItemValue);
          $('#country-input').attr('data-code', selectedCode);
        } else {
          $('#country-input').attr('data-name', '');
        }
      },

      onKeyEnterEvent: function () {
        var selectedItemValue = $('#country-input').getSelectedItemData().name,
          selectedCode = $('#country-input').getSelectedItemData().code;

        if (selectedItemValue != undefined) {
          $('#country-input').attr('data-name', selectedItemValue);
          $('#country-input').attr('data-code', selectedCode);
        } else {
          $('#country-input').attr('data-name', '');
        }
      },

      onSelectItemEvent: function () {
        var selectedItemValue = $('#country-input').getSelectedItemData().name,
          selectedCode = $('#country-input').getSelectedItemData().code;

        if (selectedItemValue != undefined) {
          $('#country-input').attr('data-name', selectedItemValue);
          $('#country-input').attr('data-code', selectedCode);
        } else {
          $('#country-input').attr('data-name', '');
        }
      },

      onHideListEvent: function () {
        var selectedItemValue = $('#country-input').getSelectedItemData().name;

        if (selectedItemValue != undefined) {
          $('#country-input').attr('data-name', selectedItemValue);
        } else {
          $('#country-input').attr('data-name', '');
        }
      },
    },

    theme: 'square',
    highlightPhrase: false,
  };

  $('#country-input').easyAutocomplete(options);

  $('#country-input').blur(function () {
    if ($('#country-input').attr('data-name') == '') $(this).val('');
  });

  var inputPhone = document.querySelectorAll('.phone-number'),
    inputFax = document.querySelectorAll('.fax-number'),
    errorMsg = document.querySelector('.error-phone-number');

  var errorMap = [
    'Número inválido',
    'Código de area inválido',
    'Muy corto',
    'Muy largo',
    'Número inválido',
  ];

  if (inputPhone) {
    inputPhone.forEach((el) => {
      createIntelInput(el);
    });
  }
  if (inputFax) {
    inputFax.forEach((el2) => {
      createIntelInput(el2);
    });
  }

  function createIntelInput(input) {
    var iti = intlTelInput(input, {
      separateDialCode: true,
      initialCountry: 'auto',
      hiddenInput: 'full_phone',
      geoIpLookup: function (callback) {
        $.get('https://ipinfo.io', function () { }, 'jsonp').always(function (
          resp,
        ) {
          var countryCode = resp && resp.country ? resp.country : 'AR';
          callback(countryCode);
        });
      },
      utilsScript: '../js/app.js',
    });

    var reset = function () {
      input.classList.remove('error');
      errorMsg.innerHTML = '';
      errorMsg.classList.add('hide');
    };

    // on blur: validate
    input.addEventListener('blur', function () {
      reset();

      if (input.value.trim()) {
        if (iti.isValidNumber()) {
          $(input).closest('.holder').removeClass('error');
        } else {
          input.classList.add('error');
          var errorCode = iti.getValidationError();
          $(input)
            .closest('.holder')
            .attr('data-error', errorMap[errorCode]);
          $(input).closest('.holder').addClass('error');
        }
      } else {
        $(input).closest('.holder').removeClass('error');
      }
    });

    input.addEventListener('change', reset);
    input.addEventListener('keyup', reset);
  }


  // Function for tabs in resources the marketing
  if ($vLang == 'es') {
    var anchorResource = [
      '#todos',
      '#ebooks',
      '#infografias',
      '#herramientas',
      '#casos-de-estudio',
      '#video',
    ];
  }

  // Indicate the position when the data is save in sessionStorage
  if ($('body main').hasClass('resources')) {
    if (
      window.location.hash != '' &&
      $.inArray(window.location.hash, anchorResource) != -1
    ) {
      var pos = $.inArray(window.location.hash, anchorResource) + 1;
      $tabsResource.attr('data-active-tab', pos);
      $tabsResource.attr('data-href', window.location.hash.substring(1));
    }
    if (!sessionStorage.getItem('resource')) {
      var $activeTab = $tabsResource.attr('data-active-tab'),
        $activeResource = $('.tab-active span').text();
      $($tabsResource).find('.tab-indicator').removeClass('active');
      $($tabsResource)
        .find('.tab-indicator[data-indicator-tab="' + $activeTab + '"]')
        .addClass('active');
      sessionStorage.setItem('resource', $activeTab);
      sessionStorage.setItem('activeTab', $activeResource);
    } else {
      var $tabIndicatorSelected = $($tabsResource).find(
        '.tab-indicator[data-indicator-tab="' +
        sessionStorage.getItem('resource') +
        '"]',
      );
      $($tabsResource).attr(
        'data-active-tab',
        sessionStorage.getItem('resource'),
      );
      $($tabsResource).attr(
        'data-href',
        $tabIndicatorSelected.attr('data-href'),
      );
      $($tabsResource).find('.tab-indicator').removeClass('active');
      $tabIndicatorSelected.addClass('active');
      $contentResources.removeClass('active');
      $('#' + $tabIndicatorSelected.attr('data-href')).addClass('active');
      $('.tab-active span').text(sessionStorage.getItem('activeTab'));

      if (history.pushState) {
        history.pushState(null, null, '#' + $($tabsResource).attr('data-href'));
      } else {
        location.hash = '#' + $($tabsResource).attr('data-href');
      }
    }
  }

  $('.tab-indicator').each(function (index) {
    $(this).on('click', function (e) {
      var $dataHref = $(this).attr('data-href'),
        $activeResource = $(this).text(),
        $submenuOptions = $(this).closest('nav').find('ul'),
        $activeTab = $(this).attr('data-indicator-tab');

      $('.nav-resources-tabs').attr('data-href', $dataHref);
      $('.nav-resources-tabs').attr('data-active-tab', index + 1);
      sessionStorage.setItem('resource', $activeTab);
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: $('.section--resources').offset().top - 50,
        },
        1000,
      );
      $('.tab-indicator').removeClass('active');
      $(this).addClass('active');
      $('.tab-active span').html($activeResource);
      sessionStorage.setItem('activeTab', $activeResource);
      $contentResources.removeClass('active');
      $('#' + $dataHref).addClass('active');

      if ($submenuOptions.hasClass('open')) {
        $submenuOptions.removeClass('open').addClass('hide');
      }
    });
  });

  $navResourcesOpen.on('click', function (e) {
    e.preventDefault();
    var $submenuOptions = $(this).closest('nav').find('ul');

    if ($submenuOptions.hasClass('open')) {
      $submenuOptions.removeClass('open').addClass('hide');
    } else {
      $submenuOptions.removeClass('hide').addClass('open');
    }
  });

  $navResourcesClose.on('click', function (e) {
    e.preventDefault();
    $(this).parent().removeClass('open').addClass('hide');
  });

  $('.share-button').on('click', function (e) {
    e.preventDefault();
    if ($(this).parent().hasClass('active')) {
      $(this).parent().removeClass('active');
    } else {
      $(this).parent().addClass('active');
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.share-resource').length) {
      $('.share-resource').removeClass('active');
    }
  });

  $copyResource.on('click', function (e) {
    e.preventDefault();
    var copyTextarea = $(this).find('.url-resource');
    copyTextarea.focus();
    copyTextarea.select();

    try {
      document.execCommand('copy');
      $('.copy-url').html('¡Copiado!');
      setTimeout(function () {
        $('.share-resource').removeClass('active');
        $('.copy-url').html('Copiar enlace');
      }, 4000);
    } catch (err) {
      console.log('Error en copiar enlace');
    }
  });

  $(document).click(function (event) {
    if ($(event.target).closest('figure')) {
      $('figure').removeClass('active');
    }
  });

  $(".dp-price-large-money").html("€");
  $(".dp-price-old-money").html("€");
}); // end document.ready

window.onload = function () {
  var $inputRange = $('.range-slider'),
    $url = window.location.hash;

  $('#opt-whatsapp').addClass('position').delay(2000).animate({ opacity: 1 }, 250);

  if ($url) {
    var $categoryId = window.location.hash.substring(1).split('#'),
      $activeTab = $('.nav-resources-tabs li a')
        .find()
        .attr('data-indicator-tab');
    console.log($categoryId);

    /* Redirect to category */
    if (
      $('#' + $categoryId) !=
      $('.resources_container .resource-content').find('#' + $categoryId)
    ) {
      $('.resource-content').removeClass('active');
      $('#' + $categoryId).addClass('active');

      /* Redirect to section resource and add cl */
      if (
        $('#' + $categoryId) !=
        $('.nav-resources-tabs li a').find().attr('data-href', $categoryId)
      ) {
        $('.tab-indicator').removeClass('active');
        $('.tab-indicator[data-href="' + $categoryId + '"]').addClass('active');

        var $activeResource = $(
          '.tab-indicator[data-href="' + $categoryId + '"]',
        ).text();

        $('.tab-active span').html($activeResource);
        sessionStorage.setItem('resource', $activeTab);
      }

      if (getUrlParameter('recurso')) {
        var $resourceId = getUrlParameter('recurso');
        if (
          $('#' + $resourceId) &&
          $('#' + $resourceId).find('a.show-download')[0] != undefined
        ) {
          $('#' + $categoryId)
            .find('#' + $resourceId)
            .addClass('active open');
          console.log($resourceId);
          $('html, body').animate(
            {
              scrollTop:
                $('#' + $categoryId)
                  .find('#' + $resourceId)
                  .offset().top - 20,
            },
            500,
          );
          event.stopPropagation();
        } else if (
          $('#' + $resourceId) &&
          $('#' + $resourceId).find('a.show-video')[0] != undefined
        ) {
          $('#' + $categoryId)
            .find('#' + $resourceId)
            .addClass('active open');
          console.log($resourceId);
          $('html, body').animate(
            {
              scrollTop:
                $('#' + $categoryId)
                  .find('#' + $resourceId)
                  .offset().top - 20,
            },
            500,
          );
          event.stopPropagation();
        }
      } else {
        console.log('No Parameters in URL');
      }

      if (getUrlParameter('dplrid')) {
        var $emailHexa = getUrlParameter('dplrid'),
          $email = fromHex($emailHexa);
        document.cookie = 'cross-site-cookie=dplrid; SameSite=None; Secure';

        $("input[type='email']").val($email);
      } else {
        console.log('No parameter email');
      }
    }
  }

  // Function to decode email
  function fromHex(h) {
    var s = '';
    for (var i = 0; i < h.length; i += 2) {
      s += String.fromCharCode(parseInt(h.substr(i, 2), 16));
    }
    return decodeURIComponent(escape(s));
  }
  // Function params url
  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
  }

};


/*Function to format number and add dots to separate thousands*/
function addCommas(nStr) {
  var charSeparate,
    $vLang = $('html').attr('lang');

  if ($vLang == 'en') {
    charSeparate = ',';
  } else {
    charSeparate = '.';
  }
  nStr += '';
  var x = nStr.split(charSeparate);
  var x1 = x[0];
  var x2 = x.length > 1 ? charSeparate + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + charSeparate + '$2');
  }
  return x1 + x2;
}

function messengerReady() {
  FxoWidget.destroy();
}

function openChatBot() {
  FxoMessenger.create();
}


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function readCookie(name) {
  var nameEQ = name + '=',
    ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export { setCookie, readCookie };


